import React, { useState } from 'react';

const IcShieldCheck = () => <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>;
const IcTrendUp = () => <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;
const IcBriefcase = () => <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" /><line x1="4" y1="22" x2="4" y2="15" /></svg>;
const IcFlow = () => <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="6" height="6" /><rect x="16" y="3" width="6" height="6" /><rect x="9" y="16" width="6" height="6" /><path d="M5 9v4h14V9" /><path d="M12 13v3" /></svg>;
const IcCheck = () => <svg viewBox="0 0 24 24" fill="none" stroke="#4A67FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const Chevron = () => <svg viewBox="0 0 24 24" fill="none" stroke="#FC7785" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

const LIFECYCLE = [
    { bg: '#4A67FF', icon: <IcShieldCheck />, title: 'Investment ready', text: 'Your Diligence Pack documents the governance and corporate health that got you here. 1-click connect to 40+ follow-on VCs once you reach Gold certification.' },
    { bg: '#FC7785', icon: <IcTrendUp />, title: 'Growth ready', text: 'Healthboost modules cover governance, financial controls, HR, IP, and compliance. Each module adds to your structured record — and your next investor’s confidence.' },
    { bg: '#6E56CF', icon: <IcBriefcase />, title: 'Exit ready', text: 'When the exit conversation starts, your Diligence Pack is already current. Buyers find nothing to chip. On a £5M exit, preventing a 10% chip is worth £500,000.' },
    { bg: '#1F8A5B', icon: <IcFlow />, title: 'One pack — every conversation', text: 'The same Diligence Pack used for your seed round, Series A, and exit. Each round builds on the last. The work compounds into a permanent asset.' },
];

const CHECKLIST = [
    'Continuous Diligence Pack', 'Governance monitoring', 'Document repository', 'Investment Readiness module',
    'InvestorMatch (40+ VCs)', '20 Healthboost modules', 'Bronze / Silver / Gold Certification', 'AI auto-population (~60%)',
    'Warranty Disclosures & Directors Questionnaires', 'Clarence AI (natural language query)', 'Permission-controlled sharing',
];

const VCPortfolioTab = () => {
    const [open, setOpen] = useState(false);

    return (
        <div role="tabpanel">

            <section className="lp-section" style={{ background: '#fff' }}>
                <div className="lp-container">
                    <h2 className="lp-h2" data-lp-reveal>Investment is the beginning. Diligentsia protects everything after.</h2>
                    <p style={{ fontSize: 'clamp(16px,2vw,19px)', color: '#4A67FF', lineHeight: 1.55, marginBottom: 16, maxWidth: 600 }} data-lp-reveal data-lp-delay="60">Always ready for the next round. Always ready for exit. At a higher valuation.</p>
                    <p className="lp-sub" data-lp-reveal data-lp-delay="120">The companies that maximise their next round valuation are not the ones that scramble to organise themselves when the conversation starts. They are the ones that never stopped being organised.</p>
                </div>
            </section>

            <section className="lp-section" style={{ background: '#FBFBFD' }}>
                <div className="lp-container">
                    <h2 className="lp-h2" style={{ maxWidth: '880px', marginBottom: 48 }} data-lp-reveal>Built for every stage of your journey.</h2>
                    <div className="lp-vc-benefits">
                        {LIFECYCLE.map((c, i) => (
                            <div className="lp-vc-benefit" key={i} style={{ background: c.bg }} data-lp-reveal data-lp-delay={i * 80}>
                                <div className="lp-vc-benefit-icon">{c.icon}</div>
                                <h3>{c.title}</h3>
                                <p>{c.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="lp-vc-accordion">
                <div className="lp-container">
                    <div className="lp-vc-accordion-row">
                        <div className="lp-vc-accordion-col">
                            <button className="lp-vc-accordion-btn" onClick={() => setOpen(o => !o)}>
                                <h2>I've already got my Drive. Why do I need Diligentsia?</h2>
                                <span className="w100 toggle">{open ? 'Show less' : 'Read the answer'}<i style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}><Chevron /></i></span>
                            </button>
                            {open && (
                                <div className="lp-vc-accordion-body">
                                    <p>Drive is a filing cabinet. Diligentsia is a diligence platform. Your Drive stores whatever you put in it — including superseded drafts and documents you forgot were there. It cannot tell you what is missing: the IP assignment you never completed, the cap table inconsistency no one has looked at since the last round. Diligentsia sits on top of your Drive, indexes what you have, adds structure and completeness scoring, and gives external parties a curated, permission-controlled knowledge base. Your Drive stays yours. What changes is what external parties see — and what you know about the gaps before they find them.</p>
                                </div>
                            )}
                        </div>
                        <div className="lp-vc-accordion-col">
                            <figure className="lp-vc-quote-card">
                                <div className="mark">“</div>
                                <blockquote>A living, breathing data room that syncs with your documents to maintain continuous readiness.</blockquote>
                                <figcaption>— Founder, advanced medtech company (active fundraising)</figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>

            <section className="lp-section" style={{ background: '#fff' }}>
                <div className="lp-container">
                    <h2 className="lp-h2" style={{ marginBottom: 48, maxWidth: 500 }} data-lp-reveal>Everything you need, in one platform.</h2>
                    <div className="lp-vc-checklist">
                        {CHECKLIST.map((t, i) => (
                            <div className="lp-vc-check-item" key={i}>
                                <IcCheck />
                                <span>{t}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </div>
    );
};

export default VCPortfolioTab;
